/* live-selling.js — live simulado sincronizado al reloj global.
 * Todos los visitantes ven el mismo segundo: posicion = (hora_servidor - ancla) mod duracion_total.
 * El programa puede venir partido en varios MP4 (Shopify acepta max. 10 min por video):
 * dos <video> se alternan y el siguiente trozo queda precargado para que el corte no se note.
 */
(function () {
  'use strict';

  var HEART = '<svg viewBox="0 0 24 24"><path fill="COLOR" d="M12 21s-7.5-4.6-10-9.3C.3 8.4 2.2 4.5 6 4.1c2.2-.2 4 1 6 3.2 2-2.2 3.8-3.4 6-3.2 3.8.4 5.7 4.3 4 7.6C19.5 16.4 12 21 12 21z"/></svg>';
  var HEART_COLORS = ['#fe2c55', '#ff6b8b', '#ffb3c6', '#ff9f1c', '#ffd54a', '#7ae582', '#5bc0eb', '#c77dff'];
  var AVATAR_COLORS = ['#e57373', '#f06292', '#ba68c8', '#7986cb', '#4fc3f7', '#4db6ac', '#81c784', '#ffb74d', '#a1887f', '#90a4ae'];

  function $(root, sel) { return root.querySelector(sel); }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }
  function hash(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return h >>> 0;
  }
  function rand(a, b) { return a + Math.random() * (b - a); }
  function store(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function fmtCount(n) {
    if (n >= 10000) return (n / 1000).toFixed(0) + 'K';
    if (n >= 1000) return (n / 1000).toFixed(1).replace('.0', '') + 'K';
    return String(n);
  }

  /* ---------- Tiempo: "75", "1:15", "0:01:15", "hace 75 segundos" ---------- */
  function parseTime(v) {
    if (typeof v === 'number') return v;
    var s = String(v == null ? '' : v).trim().toLowerCase();
    if (!s) return NaN;
    var m = s.match(/hace\s+(\d+(?:[.,]\d+)?)/);
    if (m) return parseFloat(m[1].replace(',', '.'));
    if (s.indexOf(':') >= 0) {
      var p = s.split(':').map(function (x) { return parseFloat(x.replace(',', '.')) || 0; });
      return p.reduce(function (acc, x) { return acc * 60 + x; }, 0);
    }
    return parseFloat(s.replace(',', '.'));
  }

  /* ---------- CSV (Google Sheets publicada o Excel guardado como CSV) ---------- */
  function parseCSV(text) {
    text = text.replace(/^﻿/, '');
    var first = text.split(/\r?\n/)[0] || '';
    var delim = (first.split(';').length > first.split(',').length) ? ';' : (first.indexOf('\t') >= 0 ? '\t' : ',');
    var rows = [], row = [], cell = '', q = false;
    for (var i = 0; i < text.length; i++) {
      var c = text[i];
      if (q) {
        if (c === '"') { if (text[i + 1] === '"') { cell += '"'; i++; } else q = false; }
        else cell += c;
      } else if (c === '"') q = true;
      else if (c === delim) { row.push(cell); cell = ''; }
      else if (c === '\n' || c === '\r') {
        if (c === '\r' && text[i + 1] === '\n') i++;
        row.push(cell); rows.push(row); row = []; cell = '';
      } else cell += c;
    }
    if (cell !== '' || row.length) { row.push(cell); rows.push(row); }
    return rows;
  }
  var HEADERS = {
    t: ['segundo', 'tiempo', 'seg', 'countdown', 'time', 'momento'],
    n: ['nombre', 'title', 'name', 'usuario'],
    f: ['foto', 'image', 'avatar', 'imagen'],
    c: ['comentario', 'content', 'texto', 'mensaje', 'comment'],
    k: ['tipo', 'type']
  };
  function rowsToEvents(rows) {
    if (!rows.length) return [];
    var head = rows[0].map(function (h) { return norm(h).trim(); });
    var idx = {};
    Object.keys(HEADERS).forEach(function (key) {
      for (var i = 0; i < HEADERS[key].length; i++) {
        var j = head.indexOf(HEADERS[key][i]);
        if (j >= 0) { idx[key] = j; break; }
      }
    });
    // Hoja de Pancake con columna countdown: manda countdown sobre "time".
    var cd = head.indexOf('countdown');
    if (cd >= 0) idx.t = cd;
    var out = [];
    rows.slice(1).forEach(function (r) {
      var ev = {
        t: parseTime(r[idx.t]),
        n: (r[idx.n] || '').trim(),
        f: (r[idx.f] || '').trim(),
        c: (r[idx.c] || '').trim(),
        k: norm(r[idx.k] || '').trim() || 'comentario'
      };
      if (!isNaN(ev.t) && (ev.c || ev.k !== 'comentario')) out.push(ev);
    });
    return out;
  }

  /* ======================================================================= */
  function Live(root) {
    var cfg = JSON.parse($(root, 'script[type="application/json"]').textContent);
    var self = this;
    this.root = root;
    this.cfg = cfg;
    this.segs = (cfg.segmentos || []).filter(function (s) { return s && s.url; });
    if (!this.segs.length) { root.innerHTML = '<p style="color:#fff;padding:20px">Falta configurar el video del live.</p>'; return; }
    this.anchor = Date.parse(cfg.ancla || '2026-01-01T00:00:00-05:00');
    this.offset = 0; // hora_servidor - hora_local (ms)
    this.muted = true;
    this.started = false;
    this.events = [];
    this.lastPos = null;
    this.likes = 0;
    this.guest = this.guestName();
    var conn = navigator.connection || {};
    this.sd = !!(conn.saveData || /(^|-)(2g|3g)$/.test(conn.effectiveType || '')); // red lenta o ahorro de datos: 480p de entrada
    this.recomputeTotals();
    this.build();
    this.setEvents(cfg.eventos || []);
    if (cfg.hoja_csv) this.loadSheet(cfg.hoja_csv);
    this.syncClock().then(function () { self.start(); });
    // si la hora del servidor tarda, arrancamos con el reloj local y corregimos despues
    setTimeout(function () { if (!self.started) self.start(); }, 1500);
  }

  Live.prototype.guestName = function () {
    var g = store('ls_invitado');
    if (!g) { g = 'Invitado' + Math.floor(1000 + Math.random() * 9000); store('ls_invitado', g); }
    return g;
  };

  Live.prototype.recomputeTotals = function () {
    this.cum = [];
    var t = 0;
    for (var i = 0; i < this.segs.length; i++) {
      // sin duracion configurada se asume 600 s hasta leer la real del video (loadedmetadata la corrige)
      if (!(+this.segs[i].dur > 0)) this.segs[i].dur = 600;
      this.cum.push(t); t += +this.segs[i].dur;
    }
    this.total = t;
  };

  /* ---------- Reloj: hora del servidor desde la cabecera Date de Shopify ---------- */
  Live.prototype.syncClock = function () {
    var self = this;
    if (!window.fetch) return Promise.resolve();
    var t0 = Date.now();
    var ctrl = window.AbortController ? new AbortController() : null;
    if (ctrl) setTimeout(function () { ctrl.abort(); }, 2500);
    return fetch(location.pathname + '?ls_t=' + t0, { method: 'HEAD', cache: 'no-store', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) {
        var t1 = Date.now();
        var d = Date.parse(r.headers.get('date') || '');
        if (isNaN(d)) return;
        // Date viene en segundos enteros: la hora real del servidor esta en [d, d+1000) y se sello
        // entre t0 y t1 del reloj local, asi que el desfase posible es [d - t1, d + 1000 - t0].
        // Si 0 cae ahi, el reloj del equipo es correcto (celulares sincronizados por red) y no se toca;
        // si no, se corrige lo minimo. Asi dos visitantes con buen reloj quedan casi al mismo milisegundo.
        var lo = d - t1, hi = d + 1000 - t0;
        self.offset = lo > 0 ? lo : (hi < 0 ? hi : 0);
      })
      .catch(function () {});
  };
  Live.prototype.now = function () { return Date.now() + this.offset; };
  Live.prototype.livePos = function () {
    var p = ((this.now() - this.anchor) / 1000) % this.total;
    return p < 0 ? p + this.total : p;
  };
  Live.prototype.locate = function (p) {
    for (var i = this.segs.length - 1; i >= 0; i--) if (p >= this.cum[i]) return { i: i, off: p - this.cum[i] };
    return { i: 0, off: 0 };
  };
  Live.prototype.curPos = function () {
    var v = this.active;
    if (!v || v._seg == null) return null;
    return this.cum[v._seg] + (v.currentTime || 0);
  };
  function circDiff(a, b, total) { // a - b en un circulo de largo total, en [-total/2, total/2]
    var d = (a - b) % total;
    if (d > total / 2) d -= total;
    if (d < -total / 2) d += total;
    return d;
  }

  /* ---------- Interfaz ---------- */
  Live.prototype.build = function () {
    var c = this.cfg, self = this, r = this.root;
    var host = c.anfitrion || {};
    var prod = c.producto || null;
    if (prod && prod.precio_num != null) { // "$149.900" (formato de Colombia) en vez del money de Shopify
      var fmt = function (cents) {
        var dec = prod.moneda && prod.moneda !== 'COP' ? 2 : 0;
        return '$' + (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: dec, maximumFractionDigits: dec });
      };
      prod.precio = fmt(prod.precio_num);
      if (prod.precio_antes_num) prod.precio_antes = fmt(prod.precio_antes_num);
    }
    var poster = c.poster || '';
    r.classList.add('ls-root');
    var stage = el('div', 'ls-stage');
    if (poster) { var bg = el('div', 'ls-bg'); bg.style.backgroundImage = 'url("' + poster + '")'; r.appendChild(bg); }
    r.appendChild(stage);
    this.stage = stage;

    this.videos = [0, 1].map(function () {
      var v = el('video', 'ls-video');
      v.muted = true; v.defaultMuted = true; v.playsInline = true;
      v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); v.setAttribute('muted', '');
      v.setAttribute('disablepictureinpicture', ''); v.setAttribute('x-webkit-airplay', 'deny');
      v.preload = 'metadata';
      if (poster) v.poster = poster;
      v._seg = null;
      stage.appendChild(v);
      return v;
    });
    stage.insertAdjacentHTML('beforeend',
      '<div class="ls-shade-top"></div><div class="ls-shade-bottom"></div><div class="ls-tap"></div>' +
      '<div class="ls-loading"></div><div class="ls-reconnect" hidden><i></i>Reconectando…</div>' +
      '<div class="ls-top">' +
        '<div class="ls-host"><img alt="" src="' + esc(host.foto || '') + '"><div class="ls-host-txt"><div class="ls-host-name">' + esc(host.nombre || '') + '</div><div class="ls-host-likes"><span class="ls-likes">0</span> Me gusta</div></div><button class="ls-follow" type="button">Seguir</button></div>' +
        '<div class="ls-right"><div class="ls-faces"></div><div class="ls-viewers"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z"/><circle cx="12" cy="12" r="3"/></svg><span class="ls-count">0</span></div>' +
        (c.url_cerrar ? '<a class="ls-close" href="' + esc(c.url_cerrar) + '" aria-label="Cerrar">&times;</a>' : '') + '</div>' +
      '</div>' +
      '<div class="ls-row2"><span class="ls-live"><i></i>LIVE</span>' + (c.titulo ? '<span class="ls-tag">' + esc(c.titulo) + '</span>' : '') + '</div>' +
      '<div class="ls-toasts"></div>' +
      '<button class="ls-unmute" type="button" hidden><svg viewBox="0 0 24 24" fill="#fff"><path d="M3 9v6h4l5 5V4L7 9H3z"/><path d="M16 9l6 6M22 9l-6 6" stroke="#fff" stroke-width="2"/></svg>' + esc((c.textos && c.textos.sonido) || 'Toca para activar el sonido') + '</button>' +
      '<button class="ls-enter" type="button" hidden><b><svg viewBox="0 0 24 24" fill="#fff"><path d="M6 4l15 8-15 8z"/></svg></b>' + esc((c.textos && c.textos.entrar) || 'Toca para unirte al live') + '</button>' +
      '<div class="ls-bottom">' +
        '<div class="ls-pin" hidden><b>📌</b><span></span></div>' +
        '<div class="ls-chat" aria-live="polite"></div>' +
        (prod ? '<a class="ls-product" href="' + esc(this.buyUrl(prod.url)) + '"><span class="ls-product-flag">' + esc(prod.etiqueta || 'Oferta del live') + '</span><img alt="" src="' + esc(prod.imagen || '') + '"><div class="ls-product-txt"><div class="ls-product-title">' + esc(prod.titulo || '') + '</div><div class="ls-product-price">' + esc(prod.precio || '') + (prod.precio_antes ? '<s>' + esc(prod.precio_antes) + '</s>' : '') + '</div></div><span class="ls-product-btn">' + esc(c.boton || 'Comprar') + '</span></a>' : '') +
        '<div class="ls-actions">' +
          '<form class="ls-input"><input type="text" maxlength="150" enterkeyhint="send" placeholder="' + esc((c.textos && c.textos.comentar) || 'Escribe un comentario…') + '"><button class="ls-send" type="submit" hidden>Enviar</button></form>' +
          (c.whatsapp ? '<a class="ls-icon ls-wa" href="' + esc(c.whatsapp) + '" target="_blank" rel="noopener" aria-label="WhatsApp"><svg viewBox="0 0 24 24" fill="#fff"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.3 14.1c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .2-3.3-.7-2.8-1.1-4.5-3.9-4.7-4.1-.1-.2-1.1-1.5-1.1-2.8s.7-2 1-2.3c.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.4 0 .5l-.3.5-.4.4c-.1.2-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.3 2.4 1.5.3.1.5.1.6-.1l.9-1.1c.2-.3.4-.2.6-.1l1.9.9c.3.1.5.2.5.3.1.2.1.7-.1 1.4z"/></svg></a>' : '') +
          '<button class="ls-icon ls-like" type="button" aria-label="Me gusta">' + HEART.replace('COLOR', '#fff') + '</button>' +
          (prod ? '<a class="ls-buy" href="' + esc(this.buyUrl(prod.url)) + '"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h3l2.4 11.2a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.5L21 7H6"/><circle cx="10" cy="20" r="1.4" fill="#fff"/><circle cx="17" cy="20" r="1.4" fill="#fff"/></svg>' + esc(c.boton || 'Comprar') + '</a>' : '') +
        '</div>' +
      '</div>');

    this.chat = $(stage, '.ls-chat');
    this.countEl = $(stage, '.ls-count');
    this.likesEl = $(stage, '.ls-likes');
    this.toasts = $(stage, '.ls-toasts');
    this.product = $(stage, '.ls-product');
    if (c.diseno === 'b') this.buildB(stage, prod);
    else if (c.diseno === 'c') this.buildC(stage, prod);
    if (prod && prod.url) this.rsiCache(prod.url);
    this.unmuteBtn = $(stage, '.ls-unmute');
    this.enterBtn = $(stage, '.ls-enter');
    this.loadingEl = $(stage, '.ls-loading');
    this.reconnectEl = $(stage, '.ls-reconnect');

    $(stage, '.ls-follow').addEventListener('click', function (e) {
      e.currentTarget.textContent = 'Siguiendo'; e.currentTarget.classList.add('is-done');
    });
    this.unmuteBtn.addEventListener('click', function () { self.unmute(); });
    this.enterBtn.addEventListener('click', function () { self.enterBtn.hidden = true; self.unmute(); });
    var lastTap = 0;
    // primer toque en cualquier parte que no sea un boton/enlace/campo activa el sonido
    stage.addEventListener('click', function (e) {
      if (self.muted && self.started && !e.target.closest('a,button,input,form')) self.unmute();
    }, true);
    $(stage, '.ls-tap').addEventListener('click', function (e) {
      if (self.muted) return;
      var t = Date.now();
      if (t - lastTap < 320) { self.heartAt(e.clientX - stage.getBoundingClientRect().left, e.clientY - stage.getBoundingClientRect().top); self.addLikes(1); }
      lastTap = t;
    });
    $(stage, '.ls-like').addEventListener('click', function () {
      var b = $(stage, '.ls-like').getBoundingClientRect(), s = stage.getBoundingClientRect();
      for (var i = 0; i < 3; i++) self.heartAt(b.left - s.left + b.width / 2, b.top - s.top, i * 90);
      self.addLikes(1);
    });
    // Comprar abre el formulario COD de Releasit aqui mismo (el live sigue detras);
    // si Releasit no cargo, va al producto con rsi_open_form=true, que lo abre al llegar
    stage.addEventListener('click', function (e) {
      var a = e.target.closest('.ls-buy, .ls-product, [data-buy]');
      if (!a || (/^[bc]$/.test(self.cfg.diseno) && a.classList.contains('ls-buy'))) return; // en B abre la ficha; en C, carrito o formulario
      e.preventDefault();
      self.openForm(+a.getAttribute('data-qty') || 1, a.href || self.buyUrl((self.cfg.producto || {}).url));
    });
    var form = $(stage, '.ls-input'), input = $(form, 'input'), send = $(form, '.ls-send');
    input.addEventListener('input', function () { send.hidden = !input.value.trim(); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var txt = input.value.trim();
      if (!txt) return;
      input.value = ''; send.hidden = true; input.blur();
      self.addMsg({ n: self.guest, c: txt, k: 'yo' });
      self.autoReply(txt);
    });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible' && self.started) self.resync(true);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted && self.started) self.resync(true); });

    // caras de espectadores
    var faces = $(stage, '.ls-faces');
    (c.caras || []).slice(0, 3).forEach(function (u) { faces.appendChild(el('img', '', null)).src = u; });
  };

  // Releasit arma las ofertas por cantidad con #rsi-cod-form-product-cache; fuera de /products/
  // su app embed lo deja en "null", asi que se llena con el JSON del producto (Ajax API)
  Live.prototype.rsiCache = function (url) {
    var self = this;
    fetch(url.split('?')[0] + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : null; }).then(function (txt) {
      if (!txt) return;
      try { self.pjson = JSON.parse(txt); } catch (e) {}
      if (self.cfg.diseno === 'b') self.renderPacks();
      var els = document.querySelectorAll('#rsi-cod-form-product-cache');
      if (!els.length) {
        var s = document.createElement('script');
        s.id = 'rsi-cod-form-product-cache'; s.type = 'application/json';
        (document.querySelector('.ls-rsi') || document.body).appendChild(s);
        els = [s];
      }
      for (var i = 0; i < els.length; i++) els[i].textContent = txt;
    }).catch(function () {});
  };

  // Releasit preselecciona el pack segun el input quantity del form del producto
  // items = [{id, quantity}] para varios productos (carrito del diseno C); sin items va el producto del live
  Live.prototype.openForm = function (qty, href, items) {
    var q = document.querySelector('.ls-rsi input[name="quantity"]');
    if (q) q.value = qty;
    window._RSI_COD_FORM_OVERWRITE_ATC_ITEMS = items && items.length ? items : undefined;
    var rsi = document.querySelector('.ls-rsi #_rsi-buy-now-button, .ls-rsi ._rsi-buy-now-button');
    if (rsi) { this.closeSheet(); rsi.click(); }
    else location.href = href + (href.indexOf('?') >= 0 ? '&' : '?') + 'rsi_open_form=true';
  };
  Live.prototype.closeSheet = function () {
    if (this.stage) [].forEach.call(this.stage.querySelectorAll('.lsb-sheet'), function (s) { s.hidden = true; });
  };

  Live.prototype.buyUrl = function (url) {
    if (!url) return '#';
    // conserva utm/fbclid del anuncio para no perder la atribucion
    var q = location.search.replace(/^\?/, '').split('&').filter(function (kv) { return kv && kv.indexOf('ls_t=') !== 0; });
    if (!q.length) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + q.join('&');
  };

  /* ---------- Diseno B (estilo Pancake): carrusel de packs + ficha con cuenta regresiva ---------- */
  var BAG = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h3l2.4 11.2a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.5L21 7H6"/><circle cx="10" cy="20" r="1.4" fill="#fff"/><circle cx="17" cy="20" r="1.4" fill="#fff"/></svg>';
  var SPK = '<svg viewBox="0 0 24 24" fill="#fff"><path d="M3 9v6h4l5 5V4L7 9H3z"/><path class="lsb-x" d="M16 9l6 6M22 9l-6 6" stroke="#fff" stroke-width="2"/><path class="lsb-w" d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12" stroke="#fff" stroke-width="2" fill="none"/></svg>';

  Live.prototype.buildB = function (stage, prod) {
    var c = this.cfg, self = this;
    this.root.classList.add('ls-b');
    if (c.color) this.root.style.setProperty('--ls-brand', c.color);
    $(stage, '.ls-top').insertAdjacentHTML('afterbegin', '<div class="lsb-title">' + esc(c.titulo || '') + '</div>');
    var right = $(stage, '.ls-right');
    right.insertAdjacentHTML('beforeend', '<button class="lsb-mute" type="button" aria-label="Sonido">' + SPK + '</button>');
    $(right, '.lsb-mute').addEventListener('click', function () {
      if (self.muted) self.unmute();
      else { self.muted = true; self.root.classList.remove('ls-sound'); if (self.active) self.active.muted = true; }
    });
    if (!prod) return;
    stage.insertAdjacentHTML('beforeend', '<button class="lsb-bag" type="button" aria-label="Productos">' + BAG + '</button>');
    $(stage, '.ls-actions').insertAdjacentHTML('beforebegin', '<div class="lsb-packs"><button class="lsb-packs-x" type="button" aria-label="Ocultar">&times;</button><div class="lsb-track"></div></div>');
    stage.insertAdjacentHTML('beforeend',
      '<div class="lsb-sheet" hidden><div class="lsb-shade"></div><div class="lsb-card">' +
        '<button class="lsb-sheet-x" type="button" aria-label="Cerrar">&times;</button>' +
        '<div class="lsb-img"><img alt="" src="' + esc((prod.imagen || '').replace(/width=\d+/, 'width=720')) + '"></div>' +
        '<div class="lsb-body">' +
          '<div class="lsb-head"><div><div class="lsb-name">' + esc(prod.titulo || '') + '</div><div class="lsb-prices"></div></div>' +
          '<div class="lsb-cd"><small>' + esc(c.texto_cuenta || 'Esta oferta termina en') + '</small><div class="lsb-cd-n"><span><b>00</b><i>Hora</i></span><span><b>00</b><i>Minuto</i></span><span><b>00</b><i>Segundo</i></span></div></div></div>' +
          '<div class="lsb-label">Elige tu pack</div><div class="lsb-opts"></div>' +
          (c.beneficios ? '<ul class="lsb-benefits">' + String(c.beneficios).split(/\r?\n/).filter(function (x) { return x.trim(); }).map(function (x) { return '<li>' + esc(x.trim()) + '</li>'; }).join('') + '</ul>' : '') +
        '</div>' +
        '<a class="lsb-cta" data-buy data-qty="1" href="' + esc(this.buyUrl(prod.url)) + '">' + esc(c.boton_ficha || 'COMPRAR AHORA · PAGO AL RECIBIR') + '</a>' +
      '</div></div>');
    var buy = $(stage, '.ls-buy');
    if (buy) buy.innerHTML = '<img alt="" src="' + esc(prod.imagen || '') + '">' + esc(c.boton || '¡COMPRAR!');
    this.packsEl = $(stage, '.lsb-packs');
    this.sheet = $(stage, '.lsb-sheet');
    this.selQty = 1;
    this.renderPacks();

    var openSheet = function () { self.sheet.hidden = false; self.countdown(); };
    if (buy) buy.addEventListener('click', function (e) { e.preventDefault(); openSheet(); });
    $(stage, '.lsb-bag').addEventListener('click', function () { self.showPacks(!self.packsEl.classList.contains('is-on')); });
    $(stage, '.lsb-packs-x').addEventListener('click', function () { self.showPacks(false); });
    $(stage, '.lsb-track').addEventListener('click', function (e) {
      var card = e.target.closest('.lsb-pk');
      if (!card) return;
      self.pickQty(+card.getAttribute('data-qty')); openSheet();
    });
    $(stage, '.lsb-opts').addEventListener('click', function (e) {
      var o = e.target.closest('.lsb-opt');
      if (o) self.pickQty(+o.getAttribute('data-qty'));
    });
    $(stage, '.lsb-shade').addEventListener('click', function () { self.closeSheet(); });
    $(stage, '.lsb-sheet-x').addEventListener('click', function () { self.closeSheet(); });
    setInterval(function () { if (!self.sheet.hidden) self.countdown(); }, 1000);
    setTimeout(function () { self.showPacks(true); }, 4000);
  };

  Live.prototype.showPacks = function (on) {
    if (this.packsEl) this.packsEl.classList.toggle('is-on', !!on);
  };

  // Packs = ofertas por cantidad de Releasit para este producto (mismos precios que el formulario)
  Live.prototype.packs = function () {
    var prod = this.cfg.producto || {}, pj = this.pjson;
    var base = pj ? pj.price : prod.precio_num;
    var img = (pj && pj.featured_image) || prod.imagen || '';
    var q = null, offers = window._RSI_COD_FORM_QUANTIY_OFFERS || [];
    if (pj) for (var i = 0; i < offers.length; i++) {
      if (offers[i].isActive && (offers[i].pIds || []).indexOf(String(pj.id)) >= 0) { q = offers[i]; break; }
    }
    if (!q || !base) return [{ qty: 1, titulo: prod.titulo || '', precio: base, antes: prod.precio_antes_num, badge: prod.etiqueta || '', img: img }];
    return q.offers.slice().sort(function (a, b) { return a.qty - b.qty; }).map(function (o) {
      var full = base * o.qty, d = o.ds || {};
      var pr = d.t === 'fixed' ? full - d.v : (d.t === 'percentage' ? Math.round(full * (1 - d.v / 100)) : full);
      return { qty: o.qty, titulo: o.title || (o.qty + (o.qty > 1 ? ' unidades' : ' unidad')), precio: pr, antes: pr < full ? full : null, badge: o.plaque || '', img: o.imgUrl || img };
    });
  };

  Live.prototype.money = function (cents) {
    var prod = this.cfg.producto || {};
    var dec = prod.moneda && prod.moneda !== 'COP' ? 2 : 0;
    return '$' + (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  };

  Live.prototype.renderPacks = function () {
    if (!this.packsEl) return;
    var self = this, list = this.packs();
    this.packList = list;
    $(this.packsEl, '.lsb-track').innerHTML = list.map(function (p) {
      return '<button type="button" class="lsb-pk" data-qty="' + p.qty + '">' + (p.badge ? '<em>' + esc(p.badge) + '</em>' : '') +
        '<img alt="" src="' + esc(p.img) + '"><b>' + esc(p.titulo) + '</b><span>' + esc(self.money(p.precio)) + '</span>' +
        (p.antes ? '<s>' + esc(self.money(p.antes)) + '</s>' : '') + '</button>';
    }).join('');
    $(this.sheet, '.lsb-opts').innerHTML = list.length > 1 ? list.map(function (p) {
      return '<button type="button" class="lsb-opt" data-qty="' + p.qty + '"><b>' + esc(p.titulo) + '</b>' + (p.badge ? '<em>' + esc(p.badge) + '</em>' : '') +
        '<span>' + esc(self.money(p.precio)) + (p.antes ? '<s>' + esc(self.money(p.antes)) + '</s>' : '') + '</span></button>';
    }).join('') : '';
    $(this.sheet, '.lsb-label').hidden = list.length < 2;
    this.pickQty(this.selQty);
  };

  Live.prototype.pickQty = function (qty) {
    var list = this.packList || [], p = list[0];
    for (var i = 0; i < list.length; i++) if (list[i].qty === qty) p = list[i];
    if (!p) return;
    this.selQty = p.qty;
    var s = this.sheet;
    [].forEach.call(s.querySelectorAll('.lsb-opt'), function (o) { o.classList.toggle('is-sel', +o.getAttribute('data-qty') === p.qty); });
    $(s, '.lsb-prices').innerHTML = (p.antes ? '<div class="lsb-before">Precio normal: <s>' + esc(this.money(p.antes)) + '</s></div>' : '') +
      '<div class="lsb-now">Precio del live: <b>' + esc(this.money(p.precio)) + '</b></div>';
    $(s, '.lsb-cta').setAttribute('data-qty', p.qty);
  };

  // La oferta del live termina cuando termina la vuelta del programa (igual para todos los visitantes)
  Live.prototype.countdown = function () {
    var left = Math.max(0, Math.floor(this.total - this.livePos()));
    if (left < 120) left += Math.floor(this.total); // no mostrar segundos sueltos: pasa a la siguiente vuelta
    var b = this.sheet.querySelectorAll('.lsb-cd-n b');
    var v = [Math.floor(left / 3600), Math.floor(left / 60) % 60, left % 60];
    for (var i = 0; i < 3; i++) b[i].textContent = (v[i] < 10 ? '0' : '') + v[i];
  };

  /* ---------- Diseno C (calcado de Pancake): productos, ficha con -/+ y carrito; cierra con Releasit ---------- */
  function stripHtml(h) { var d = document.createElement('div'); d.innerHTML = h || ''; return (d.textContent || '').replace(/\s+/g, ' ').trim(); }

  Live.prototype.buildC = function (stage, prod) {
    var c = this.cfg, self = this;
    this.root.classList.add('ls-c');
    if (c.color) this.root.style.setProperty('--ls-brand', c.color);
    $(stage, '.ls-top').insertAdjacentHTML('afterbegin', '<div class="lsb-title">' + esc(c.titulo || '') + '</div>');
    var right = $(stage, '.ls-right');
    right.insertAdjacentHTML('beforeend', '<button class="lsb-mute" type="button" aria-label="Sonido">' + SPK + '</button>');
    $(right, '.lsb-mute').addEventListener('click', function () {
      if (self.muted) self.unmute();
      else { self.muted = true; self.root.classList.remove('ls-sound'); if (self.active) self.active.muted = true; }
    });
    var input = $(stage, '.ls-input input');
    if (input) input.placeholder = (c.textos && c.textos.comentar) || '¡Deja tu comentario aquí! 👇';
    if (!prod) return;
    stage.insertAdjacentHTML('beforeend', '<button class="lsb-bag lsc-cart-btn" type="button" aria-label="Carrito">' + BAG + '<i class="lsc-badge" hidden>0</i></button>');
    $(stage, '.ls-actions').insertAdjacentHTML('beforebegin', '<div class="lsb-packs"><button class="lsb-packs-x" type="button" aria-label="Ocultar">&times;</button><div class="lsb-track"></div></div>');
    stage.insertAdjacentHTML('beforeend',
      '<div class="lsb-sheet lsc-ficha" hidden><div class="lsb-shade"></div><div class="lsb-card">' +
        '<button class="lsb-sheet-x" type="button" aria-label="Cerrar">&times;</button>' +
        '<div class="lsb-img"><img alt="" src=""></div>' +
        '<div class="lsb-body">' +
          '<div class="lsb-head"><div class="lsb-name"></div>' +
          '<div class="lsb-cd"><small>' + esc(c.texto_cuenta || 'Está oferta termina en') + '</small><div class="lsb-cd-n"><span><b>00</b><i>Hora</i></span><span><b>00</b><i>Minuto</i></span><span><b>00</b><i>Segundo</i></span></div></div></div>' +
          '<div class="lsc-prices"></div>' +
          '<div class="lsc-row"><span>Selecciona la cantidad</span><div class="lsc-qty"><button type="button" data-d="-1">−</button><b>1</b><button type="button" data-d="1">+</button></div></div>' +
          '<div class="lsc-row lsc-desc-t">Descripción del producto</div><div class="lsc-desc"></div>' +
        '</div>' +
        '<div class="lsc-btns"><button type="button" class="lsc-add">AGREGAR AL CARRITO</button><button type="button" class="lsc-now">COMPRAR AHORA</button></div>' +
      '</div></div>' +
      '<div class="lsb-sheet lsc-carro" hidden><div class="lsb-shade"></div><div class="lsb-card">' +
        '<button class="lsb-sheet-x" type="button" aria-label="Cerrar">&times;</button>' +
        '<div class="lsc-sub">Subtotal de tu pedido: <b>$0</b></div>' +
        '<div class="lsb-body"><div class="lsc-items"></div><p class="lsc-empty">Tu carrito está vacío</p></div>' +
        '<div class="lsc-btns"><button type="button" class="lsc-now lsc-checkout">FINALIZAR PEDIDO · PAGO AL RECIBIR</button></div>' +
      '</div></div>' +
      '<div class="lsc-toast" hidden>Añadido al carrito ✓</div>');
    var buy = $(stage, '.ls-buy');
    if (buy) buy.innerHTML = '<img alt="" src="' + esc(prod.imagen || '') + '">' + esc(c.boton || '¡COMPRAR!');
    this.packsEl = $(stage, '.lsb-packs');
    this.ficha = $(stage, '.lsc-ficha');
    this.sheet = this.ficha; // la cuenta regresiva y closeSheet usan this.sheet
    this.carro = $(stage, '.lsc-carro');
    this.cart = [];
    try { this.cart = JSON.parse(store('ls_carrito') || '[]') || []; } catch (e) {}
    this.prods = {};

    // productos: el del live primero y luego los extra (handles en "productos_extra")
    var handles = [String(prod.url || '').split('/products/')[1]].concat(String(c.productos_extra || '').split(/[\s,]+/))
      .map(function (h) { return (h || '').split('?')[0].trim(); })
      .filter(function (h, i, a) { return h && a.indexOf(h) === i; });
    this.handles = handles;
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (list) {
      list.forEach(function (p) { if (p && p.available !== false) self.prods[p.handle] = p; });
      self.renderProds(); self.renderCart();
    });

    if (buy) buy.addEventListener('click', function (e) {
      e.preventDefault();
      if (self.cart.length) self.checkout(); else self.openForm(1, self.buyUrl(prod.url));
    });
    $(stage, '.lsc-cart-btn').addEventListener('click', function () { self.renderCart(); self.carro.hidden = false; });
    $(stage, '.lsb-packs-x').addEventListener('click', function () { self.showPacks(false); });
    $(stage, '.lsb-track').addEventListener('click', function (e) {
      var card = e.target.closest('.lsb-pk');
      if (card) self.openFicha(card.getAttribute('data-h'));
    });
    $(this.ficha, '.lsc-qty').addEventListener('click', function (e) {
      var d = +(e.target.getAttribute('data-d') || 0);
      if (!d) return;
      self.fqty = Math.max(1, Math.min(10, self.fqty + d));
      $(self.ficha, '.lsc-qty b').textContent = self.fqty;
    });
    $(this.ficha, '.lsc-add').addEventListener('click', function () { self.addToCart(self.fh, self.fqty); self.ficha.hidden = true; });
    $(this.ficha, '.lsc-now').addEventListener('click', function () {
      var p = self.prods[self.fh];
      if (self.fh === handles[0]) self.openForm(self.fqty, self.buyUrl(prod.url));
      else if (p) self.openForm(1, '/products/' + p.handle, [{ id: p.variants[0].id, quantity: self.fqty }]);
    });
    $(this.carro, '.lsc-items').addEventListener('click', function (e) {
      var b = e.target.closest('[data-i]');
      if (!b) return;
      var i = +b.getAttribute('data-i'), d = +b.getAttribute('data-d');
      if (!self.cart[i]) return;
      self.cart[i].q += d;
      if (self.cart[i].q < 1 || d === 0) self.cart.splice(i, 1);
      self.saveCart();
    });
    $(this.carro, '.lsc-checkout').addEventListener('click', function () { if (self.cart.length) self.checkout(); });
    [this.ficha, this.carro].forEach(function (s) {
      $(s, '.lsb-shade').addEventListener('click', function () { s.hidden = true; });
      $(s, '.lsb-sheet-x').addEventListener('click', function () { s.hidden = true; });
    });
    setInterval(function () { if (!self.ficha.hidden) self.countdownC(); }, 1000);
    setTimeout(function () { self.showPacks(true); }, 4000);
  };

  Live.prototype.renderProds = function () {
    var self = this;
    $(this.packsEl, '.lsb-track').innerHTML = this.handles.filter(function (h) { return self.prods[h]; }).map(function (h) {
      var p = self.prods[h];
      return '<button type="button" class="lsb-pk" data-h="' + esc(h) + '"><img alt="" src="' + esc(p.featured_image || '') + '"><span>' + esc(self.money(p.price)) + '</span></button>';
    }).join('');
  };

  Live.prototype.openFicha = function (h) {
    var p = this.prods[h];
    if (!p) return;
    var f = this.ficha;
    this.fh = h; this.fqty = 1;
    $(f, '.lsb-img img').src = p.featured_image || '';
    $(f, '.lsb-name').textContent = p.title;
    var antes = p.compare_at_price > p.price ? p.compare_at_price : 0;
    $(f, '.lsc-prices').innerHTML = (antes ? '<div class="lsb-before">Precio original: <s>' + esc(this.money(antes)) + '</s></div>' : '') +
      '<div class="lsb-now">Precio de venta: <b>' + esc(this.money(p.price)) + '</b></div>';
    $(f, '.lsc-qty b').textContent = '1';
    var d = stripHtml(p.description);
    $(f, '.lsc-desc').textContent = d.length > 420 ? d.slice(0, 420) + '…' : d;
    f.hidden = false;
    this.countdownC();
  };

  // Cuenta regresiva por visitante, como Pancake (se guarda para que recargar no la reinicie)
  Live.prototype.countdownC = function () {
    var min = +this.cfg.cuenta_min || 10, now = Date.now();
    var end = +store('ls_cuenta_fin') || 0;
    if (end <= now) { end = now + min * 60000; store('ls_cuenta_fin', String(end)); }
    var left = Math.floor((end - now) / 1000);
    var b = this.ficha.querySelectorAll('.lsb-cd-n b');
    var v = [Math.floor(left / 3600), Math.floor(left / 60) % 60, left % 60];
    for (var i = 0; i < 3; i++) b[i].textContent = (v[i] < 10 ? '0' : '') + v[i];
  };

  Live.prototype.addToCart = function (h, q) {
    var p = this.prods[h];
    if (!p) return;
    var it = null;
    for (var i = 0; i < this.cart.length; i++) if (this.cart[i].h === h) it = this.cart[i];
    if (it) it.q += q; else this.cart.push({ h: h, q: q });
    this.saveCart();
    var t = $(this.stage, '.lsc-toast');
    t.hidden = false; clearTimeout(this._ct);
    this._ct = setTimeout(function () { t.hidden = true; }, 1800);
  };

  Live.prototype.saveCart = function () {
    store('ls_carrito', JSON.stringify(this.cart));
    this.renderCart();
  };

  Live.prototype.renderCart = function () {
    var self = this, sub = 0, n = 0;
    this.cart = this.cart.filter(function (it) { return self.prods[it.h] || !Object.keys(self.prods).length; });
    $(this.carro, '.lsc-items').innerHTML = this.cart.map(function (it, i) {
      var p = self.prods[it.h];
      if (!p) return '';
      // solo el producto del live en el carrito: Releasit le aplica su oferta por cantidad, asi que se muestra ese precio;
      // con varios productos Releasit cobra precio normal
      var full = p.price * it.q, line = full;
      if (self.cart.length === 1 && it.h === self.handles[0] && self.pjson) self.packs().forEach(function (pk) { if (pk.qty === it.q) line = pk.precio; });
      var antes = line < full ? full : (p.compare_at_price > p.price ? p.compare_at_price * it.q : 0);
      sub += line; n += it.q;
      return '<div class="lsc-item"><img alt="" src="' + esc(p.featured_image || '') + '"><div class="lsc-item-t"><b>' + esc(p.title) + '</b>' +
        (antes ? '<s>' + esc(self.money(antes)) + '</s>' : '') + '<span>' + esc(self.money(line)) + '</span>' +
        '<div class="lsc-qty"><button type="button" data-i="' + i + '" data-d="-1">−</button><b>' + it.q + '</b><button type="button" data-i="' + i + '" data-d="1">+</button></div></div>' +
        '<button type="button" class="lsc-del" data-i="' + i + '" data-d="0" aria-label="Quitar">&times;</button></div>';
    }).join('');
    $(this.carro, '.lsc-sub b').textContent = this.money(sub);
    $(this.carro, '.lsc-empty').hidden = this.cart.length > 0;
    $(this.carro, '.lsc-checkout').disabled = !this.cart.length;
    var badge = $(this.stage, '.lsc-badge');
    badge.hidden = !n; badge.textContent = n;
  };

  Live.prototype.checkout = function () {
    var self = this;
    var items = this.cart.map(function (it) { var p = self.prods[it.h]; return p ? { id: p.variants[0].id, quantity: it.q } : null; }).filter(Boolean);
    if (!items.length) return;
    this.carro.hidden = true;
    var main = this.handles[0];
    // solo el producto del live: formulario normal, con sus ofertas por cantidad
    if (this.cart.length === 1 && this.cart[0].h === main) this.openForm(this.cart[0].q, this.buyUrl((this.cfg.producto || {}).url));
    else this.openForm(1, '/products/' + this.cart[0].h, items);
  };

  /* ---------- Video ---------- */
  Live.prototype.start = function () {
    if (this.started) return;
    this.started = true;
    var self = this;
    var p = this.livePos(), loc = this.locate(p);
    this.active = this.videos[0];
    this.spare = this.videos[1];
    this.loadInto(this.active, loc.i, loc.off, true);
    this.prepSpare();
    this.wire(this.videos[0]);
    this.wire(this.videos[1]);
    // primera tanda de comentarios: como si el live llevara rato
    this.lastPos = null;
    setInterval(function () { self.tick(); }, 250);
    setInterval(function () { self.checkDrift(); }, 1000);
    this.viewersLoop();
    this.likesLoop();
    setTimeout(function () { self.addMsg({ n: self.guest, k: 'unido' }); }, 1800);
    if (this.cfg.saludo_invitado) {
      var host = this.cfg.anfitrion || {};
      setTimeout(function () {
        self.addMsg({ n: host.nombre, f: host.foto, c: self.cfg.saludo_invitado, k: 'anfitrion' });
      }, rand(7000, 11000));
    }
  };

  Live.prototype.wire = function (v) {
    var self = this;
    v.addEventListener('ended', function () { if (v === self.active) self.swap(); });
    v.addEventListener('playing', function () {
      if (v !== self.active) return;
      self.loadingEl.hidden = true;
      self.reconnectEl.hidden = true;
      self.errTries = 0;
      clearTimeout(self.waitTimer);
      if (!v._corrected) { v._corrected = true; self.checkDrift(true); }
    });
    v.addEventListener('waiting', function () {
      if (v !== self.active) return;
      clearTimeout(self.waitTimer);
      self.waitTimer = setTimeout(function () {
        if (v !== self.active || v.readyState >= 3) return;
        self.reconnectEl.hidden = false;
        // conexion lenta: pasar a la version liviana (480p) que Shopify genera de cada trozo
        if (!self.sd && self.segs.some(function (s) { return s.sd; })) { self.sd = true; self.resync(true, true); }
      }, 2500);
    });
    v.addEventListener('pause', function () {
      // iOS pausa al bloquear pantalla o al salir del viewport: reanudamos al minuto real
      if (v === self.active && !v.ended && !v.error && document.visibilityState === 'visible') {
        setTimeout(function () { if (v === self.active && v.paused && !v.ended) self.resync(true); }, 400);
      }
    });
    v.addEventListener('error', function () {
      if (v !== self.active) { // el trozo de reserva fallo: se reintenta cargarlo despues
        v._seg = null;
        setTimeout(function () { if (v === self.spare) self.prepSpare(); }, 3000);
        return;
      }
      self.reconnectEl.hidden = false;
      self.errTries = (self.errTries || 0) + 1;
      var wait = Math.min(30000, 1000 * Math.pow(2, self.errTries)); // 2, 4, 8 ... 30 s
      clearTimeout(self.errTimer);
      self.errTimer = setTimeout(function () { if (v === self.active) self.resync(true, true); }, wait);
    });
  };

  Live.prototype.segUrl = function (i) {
    var s = this.segs[i];
    return (this.sd && s.sd) ? s.sd : s.url;
  };

  Live.prototype.loadInto = function (v, segIdx, off, play) {
    var self = this, seg = this.segs[segIdx];
    v._corrected = false;
    var id = v._loadId = (v._loadId || 0) + 1;
    var apply = function () {
      if (id !== v._loadId) return; // una carga vieja que llego tarde no toca nada
      if (v.duration && isFinite(v.duration) && Math.abs(v.duration - seg.dur) > 0.3) {
        // la duracion real manda sobre la configurada
        seg.dur = v.duration; self.recomputeTotals();
      }
      if (play) {
        // al terminar de cargar ya pasaron unos segundos del live: posicion fresca
        var loc = self.locate(self.livePos());
        if (loc.i === segIdx) off = loc.off;
      }
      try { v.currentTime = Math.min(off, Math.max(0, (v.duration || seg.dur) - 0.5)); } catch (e) {}
      if (play) self.playEl(v);
    };
    var url = this.segUrl(segIdx);
    if (v._seg !== segIdx || !v.currentSrc || v.error || v._url !== url) {
      v._seg = segIdx;
      v._url = url;
      v._warm = false;
      v.preload = 'auto';
      if (v._onMeta) v.removeEventListener('loadedmetadata', v._onMeta);
      v._onMeta = function () { v.removeEventListener('loadedmetadata', v._onMeta); v._onMeta = null; apply(); };
      v.addEventListener('loadedmetadata', v._onMeta);
      v.src = url + (off > 1 ? '#t=' + off.toFixed(2) : '');
      v.load();
    } else apply();
    if (play) this.show(v);
  };

  Live.prototype.playEl = function (v) {
    var self = this;
    v.muted = this.muted;
    var pr = v.play();
    if (pr && pr.catch) {
      pr.catch(function (err) {
        if (v !== self.active || v.error || (err && err.name === 'AbortError')) return;
        if (!v.muted) { // el navegador no deja sonido sin toque: seguimos en silencio
          v.muted = true; self.muted = true; self.unmuteBtn.hidden = false; self.root.classList.remove('ls-sound');
          v.play().catch(function () { self.needTap(); });
        } else self.needTap();
      });
    }
    if (this.muted && this.enterBtn.hidden) this.unmuteBtn.hidden = false;
  };

  Live.prototype.needTap = function () { // autoplay bloqueado (p. ej. modo bajo consumo en iPhone)
    this.loadingEl.hidden = true;
    this.unmuteBtn.hidden = true;
    this.enterBtn.hidden = false;
  };

  Live.prototype.show = function (v) {
    var o = v === this.videos[0] ? this.videos[1] : this.videos[0];
    v.classList.add('is-on');
    o.classList.remove('is-on');
  };

  Live.prototype.prepSpare = function () {
    var next = (this.active._seg + 1) % this.segs.length;
    var s = this.spare, url = this.segUrl(next);
    if (s._seg === next && s.currentSrc && !s.error && s._url === url) return;
    s._seg = next;
    s._url = url;
    s._warm = false;
    s._loadId = (s._loadId || 0) + 1;
    if (s._onMeta) { s.removeEventListener('loadedmetadata', s._onMeta); s._onMeta = null; }
    s.preload = 'metadata';
    s.src = url;
    s.load();
  };

  Live.prototype.usable = function (v, seg) {
    return v._seg === seg && !!v.currentSrc && !v.error && v.readyState >= 1 && v._url === this.segUrl(seg);
  };

  Live.prototype.swap = function () {
    var old = this.active, nv = this.spare;
    var next = (old._seg + 1) % this.segs.length;
    this.active = nv; this.spare = old;
    if (!this.usable(nv, next)) this.loadInto(nv, next, 0, true);
    else {
      try { nv.currentTime = 0; } catch (e) {}
      nv._corrected = false;
      this.playEl(nv);
      this.show(nv);
    }
    try { old.pause(); } catch (e) {}
    old._warm = false;
    var self = this;
    setTimeout(function () { self.prepSpare(); }, 1500);
  };

  Live.prototype.checkDrift = function (force) {
    var v = this.active;
    if (!v || v.error) return; // los errores los maneja su listener, con reintentos
    if (v.seeking || v.readyState < 1) return;
    // 40 s antes del corte se "calienta" el siguiente trozo: Safari de iPhone ignora preload y no
    // descarga nada hasta un play(), asi que se le da play en silencio y se deja en pausa en el segundo 0
    var dur = v.duration || this.segs[v._seg].dur, s = this.spare;
    if (dur - v.currentTime < 40 && !s._warm && s.currentSrc && !s.error) {
      s._warm = true;
      s.preload = 'auto';
      s.muted = true;
      var pr = s.play();
      var park = function () { if (s !== this.active) { try { s.pause(); s.currentTime = 0; } catch (e) {} } }.bind(this);
      if (pr && pr.then) pr.then(park, function () {}); else park();
    }
    // mientras descarga (conexion lenta) no se salta: saltar bota lo descargado y nunca arrancaria
    if (v.readyState < 3 && !v.paused) return;
    var cur = this.curPos();
    if (cur == null) return;
    var d = circDiff(this.livePos(), cur, this.total);
    var tol = force ? 1.2 : (this.slowTol || 3);
    if (Math.abs(d) > tol) {
      // si hubo que resincronizar hace poco, la red no da: se tolera mas desfase antes de volver a saltar
      var now = Date.now();
      this.slowTol = (this.lastResync && now - this.lastResync < 30000) ? Math.min((this.slowTol || 3) * 2, 60) : 3;
      this.lastResync = now;
      v.playbackRate = 1;
      this.resync(false);
      return;
    }
    // desfase chico: alcanzar acelerando o frenando un 6% (no se nota y no hay salto de imagen)
    var rate = Math.abs(d) < 0.15 ? 1 : (Math.abs(d) > 0.5 || v.playbackRate !== 1 ? (d > 0 ? 1.06 : 0.94) : 1);
    if (v.playbackRate !== rate) v.playbackRate = rate;
  };

  Live.prototype.resync = function (andPlay, reload) {
    var loc = this.locate(this.livePos());
    var v = this.active, s = this.spare;
    if (reload || v.error) v._seg = null;
    if (v._seg === loc.i && v.currentSrc && !v.error && v._url === this.segUrl(loc.i)) {
      try { v.currentTime = loc.off; } catch (e) {}
      if (andPlay || v.paused) this.playEl(v);
    } else if (this.usable(s, loc.i)) { // el trozo que toca ya esta cargado en la reserva
      this.active = s; this.spare = v;
      try { s.currentTime = loc.off; } catch (e) {}
      s._corrected = false;
      this.playEl(s);
      this.show(s);
      try { v.pause(); } catch (e) {}
      this.prepSpare();
    } else {
      this.loadInto(v, loc.i, loc.off, true);
      this.prepSpare();
    }
  };

  Live.prototype.unmute = function () {
    this.muted = false;
    this.root.classList.add('ls-sound');
    this.unmuteBtn.hidden = true;
    this.enterBtn.hidden = true;
    var a = this.active, s = this.spare;
    if (a && (a.error || a.readyState === 0)) this.resync(true, true);
    else if (a) { a.muted = false; this.playEl(a); }
    // iOS: "bendecir" el reproductor de reserva dentro del mismo toque (en silencio, para no pisar
    // el audio del activo); asi los cortes y el modo bajo consumo no vuelven a pedir toque
    if (s && s.currentSrc && !s.error && s.paused) {
      s.muted = true;
      var pr = s.play();
      var back = function () { if (s !== this.active) { try { s.pause(); s.currentTime = 0; } catch (e) {} } }.bind(this);
      if (pr && pr.then) pr.then(back, function () {}); else back();
    }
  };

  /* ---------- Comentarios ---------- */
  Live.prototype.setEvents = function (evs) {
    this.events = evs.map(function (e) {
      return { t: parseTime(e.t), n: e.n || '', f: e.f || '', c: e.c || '', k: norm(e.k || 'comentario') };
    }).filter(function (e) { return !isNaN(e.t); }).sort(function (a, b) { return a.t - b.t; });
    if (this.lastPos != null) { this.chat.innerHTML = ''; this.lastPos = null; }
    var faces = $(this.stage, '.ls-faces'), seen = {};
    if (!faces.children.length) {
      for (var i = 0; i < this.events.length && faces.children.length < 3; i++) {
        var f = this.events[i].f;
        if (f && !seen[f] && this.events[i].k !== 'anfitrion') { seen[f] = 1; faces.appendChild(el('img')).src = f; }
      }
    }
  };

  Live.prototype.loadSheet = function (url) {
    var self = this;
    fetch(url, { cache: 'no-store' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (txt) {
      var evs = txt ? rowsToEvents(parseCSV(txt)) : [];
      if (evs.length) self.setEvents(evs);
    }).catch(function () {});
  };

  Live.prototype.tick = function () {
    var p = this.curPos();
    var v = this.active;
    if (p == null || !v || v.readyState < 2 || !this.events.length) return;
    var evs = this.events, last = this.lastPos, out = [];
    if (last == null) {
      // al entrar: los ultimos comentarios anteriores, sin animacion
      var chatEv = evs.filter(function (e) { return e.k === 'comentario' || e.k === 'anfitrion'; });
      var hist = chatEv.filter(function (e) { return e.t <= p; }).slice(-6);
      if (hist.length < 6) { // recien empezo la vuelta: completar con el final de la vuelta anterior
        hist = chatEv.filter(function (e) { return e.t > p + 30; }).slice(-(6 - hist.length)).concat(hist);
      }
      var self = this;
      var host = this.cfg.anfitrion || {};
      hist.forEach(function (e) {
        self.addMsg(e.k === 'anfitrion' ? { n: e.n || host.nombre, f: e.f || host.foto, c: e.c, k: 'anfitrion' } : e, true);
      });
      var pins = evs.filter(function (e) { return e.k === 'fijado' && e.t <= p; });
      if (pins.length) this.fire(pins[pins.length - 1]);
      this.lastPos = p;
      return;
    }
    if (p < last - 2) { // dio la vuelta al bucle (o retrocedio por resincronizacion)
      if (last - p > this.total / 2) out = evs.filter(function (e) { return e.t > last || e.t <= p; });
      this.lastPos = p;
    } else {
      out = evs.filter(function (e) { return e.t > last && e.t <= p; });
      this.lastPos = p;
    }
    if (out.length > 5) out = out.slice(-3); // salto grande (pestana en segundo plano): no inundar
    for (var i = 0; i < out.length; i++) this.fire(out[i]);
  };

  Live.prototype.fire = function (e) {
    var host = this.cfg.anfitrion || {};
    switch (e.k) {
      case 'producto':
        if (this.packsEl) this.showPacks(true);
        if (this.product) {
          var pr = this.product;
          pr.classList.remove('is-hot'); void pr.offsetWidth; pr.classList.add('is-hot');
        }
        if (e.c) this.addMsg({ n: e.n || host.nombre, f: e.f || host.foto, c: e.c, k: 'anfitrion' });
        break;
      case 'compra':
        this.toast(e);
        break;
      case 'fijado':
        var pin = $(this.stage, '.ls-pin');
        pin.hidden = !e.c;
        $(pin, 'span').textContent = e.c;
        break;
      case 'anfitrion':
        this.addMsg({ n: e.n || host.nombre, f: e.f || host.foto, c: e.c, k: 'anfitrion' });
        break;
      default:
        this.addMsg(e);
    }
  };

  Live.prototype.avatar = function (name, foto) {
    if (foto) { var i = el('img'); i.alt = ''; i.loading = 'lazy'; i.src = foto; return i; }
    var s = el('span', 'ls-ini');
    var clean = String(name || '?').replace(/[^A-Za-zÁÉÍÓÚÑáéíóúñ0-9 ]/g, '').trim();
    s.textContent = (clean[0] || '?').toUpperCase();
    s.style.background = AVATAR_COLORS[hash(String(name)) % AVATAR_COLORS.length];
    return s;
  };

  Live.prototype.fill = function (s) {
    var prod = this.cfg.producto || {};
    return String(s == null ? '' : s).replace(/\{precio\}/g, prod.precio || '').replace(/\{invitado\}/g, this.guest);
  };

  Live.prototype.addMsg = function (e, noAnim) {
    var row = el('div', 'ls-msg' + (noAnim ? ' no-anim' : ''));
    var k = e.k;
    e = { n: e.n, f: e.f, c: this.fill(e.c), k: k };
    if (k === 'unido') {
      row.classList.add('is-join');
      row.appendChild(this.avatar(e.n, e.f));
      row.appendChild(el('div', 'ls-bubble', '<span class="ls-name">' + esc(e.n) + '</span> ' + esc(e.c || 'se unió') + ' 👋'));
    } else {
      if (k === 'anfitrion') row.classList.add('is-host');
      if (k === 'yo') row.classList.add('is-me');
      row.appendChild(this.avatar(e.n, e.f));
      row.appendChild(el('div', 'ls-bubble', '<span class="ls-name">' + esc(e.n) + (k === 'anfitrion' ? '<span class="ls-badge">Anfitrión</span>' : '') + '</span>' + esc(e.c)));
    }
    this.chat.appendChild(row);
    while (this.chat.children.length > 40) this.chat.removeChild(this.chat.firstChild);
  };

  Live.prototype.toast = function (e) {
    var t = el('div', 'ls-toast');
    t.appendChild(this.avatar(e.n, e.f));
    t.appendChild(el('span', '', esc(this.fill(e.c) || (e.n + ' acaba de comprar 🛍️'))));
    this.toasts.appendChild(t);
    setTimeout(function () { t.classList.add('is-out'); }, 3800);
    setTimeout(function () { t.remove(); }, 4300);
  };

  Live.prototype.autoReply = function (txt) {
    var self = this, host = this.cfg.anfitrion || {}, n = norm(txt);
    var rules = this.cfg.respuestas || [];
    if (typeof rules === 'string') { // "precio, cuanto, vale | El precio es {precio}" (una regla por linea)
      rules = rules.split(/\r?\n/).map(function (l) {
        var i = l.indexOf('|');
        return i < 0 ? null : { claves: l.slice(0, i).split(','), texto: l.slice(i + 1).trim() };
      }).filter(Boolean);
      this.cfg.respuestas = rules;
    }
    var hit = null;
    for (var i = 0; i < rules.length && !hit; i++) {
      var keys = rules[i].claves || [];
      for (var j = 0; j < keys.length; j++) if (n.indexOf(norm(keys[j])) >= 0) { hit = rules[i]; break; }
    }
    var text = hit ? hit.texto : null;
    if (!text && this.cfg.respuesta_general && (!this.lastGeneric || Date.now() - this.lastGeneric > 40000)) {
      text = this.cfg.respuesta_general; this.lastGeneric = Date.now();
    }
    if (!text) return;
    setTimeout(function () {
      self.addMsg({ n: host.nombre, f: host.foto, c: '@' + self.guest + ' ' + text, k: 'anfitrion' });
    }, rand(4500, 8500));
  };

  /* ---------- Espectadores y me gusta (dependen de la hora: todos ven cifras parecidas) ---------- */
  function smooth(x, seed) { // ruido suave 0..1
    var i = Math.floor(x), f = x - i;
    var a = (hash(seed + ':' + i) % 1000) / 1000, b = (hash(seed + ':' + (i + 1)) % 1000) / 1000;
    var u = f * f * (3 - 2 * f);
    return a + (b - a) * u;
  }
  Live.prototype.viewers = function () {
    var e = this.cfg.espectadores || {};
    var base = +e.base || 150, varr = +e.variacion || 60;
    var s = this.now() / 1000;
    var v = base + varr * (smooth(s / 90, 'a') - 0.5) * 1.6 + varr * 0.4 * (smooth(s / 13, 'b') - 0.5);
    return Math.max(3, Math.round(v)) + 1; // +1 = el visitante
  };
  Live.prototype.viewersLoop = function () {
    var self = this;
    var upd = function () { self.countEl.textContent = fmtCount(self.viewers()); setTimeout(upd, rand(2500, 6000)); };
    upd();
  };
  Live.prototype.addLikes = function (n) {
    this.likes += n;
    this.likesEl.textContent = fmtCount(this.likes);
  };
  Live.prototype.likesLoop = function () {
    var self = this;
    var s = this.now() / 1000;
    var perMin = +((this.cfg.espectadores || {}).likes_min) || 90;
    this.likes = Math.round(((this.livePos() / 60) * perMin) + 300 + (hash('l' + Math.floor(s / 3600)) % 400));
    this.addLikes(0);
    var btn = $(this.stage, '.ls-like');
    var loop = function () {
      if (document.visibilityState === 'visible' && self.started) {
        var b = btn.getBoundingClientRect(), st = self.stage.getBoundingClientRect();
        var k = Math.random() < 0.25 ? 3 : 1;
        for (var i = 0; i < k; i++) self.heartAt(b.left - st.left + b.width / 2, b.top - st.top, i * 120);
        self.addLikes(Math.ceil(rand(1, 6)));
      }
      setTimeout(loop, rand(700, 2600));
    };
    setTimeout(loop, 3000);
  };
  Live.prototype.heartAt = function (x, y, delay) {
    var stage = this.stage;
    setTimeout(function () {
      var h = el('div', 'ls-heart', HEART.replace('COLOR', HEART_COLORS[Math.floor(Math.random() * HEART_COLORS.length)]));
      var size = rand(22, 36);
      h.style.width = h.style.height = size + 'px';
      h.style.left = (x - size / 2) + 'px';
      h.style.top = (y - size / 2) + 'px';
      stage.appendChild(h);
      var dx = rand(-50, 30), dy = rand(-200, -130), dur = rand(1300, 2200);
      if (h.animate) {
        h.animate([
          { transform: 'translate(0,0) scale(.4)', opacity: 0 },
          { transform: 'translate(' + dx * 0.3 + 'px,' + dy * 0.2 + 'px) scale(1.1)', opacity: 1, offset: 0.15 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.9) rotate(' + rand(-25, 25) + 'deg)', opacity: 0 }
        ], { duration: dur, easing: 'ease-out', fill: 'forwards' });
      }
      setTimeout(function () { h.remove(); }, dur + 50);
    }, delay || 0);
  };

  function boot() {
    var roots = document.querySelectorAll('[data-live-selling]');
    for (var i = 0; i < roots.length; i++) if (!roots[i]._live) roots[i]._live = new Live(roots[i]);
  }
  window.LiveSelling = { parseCSV: parseCSV, rowsToEvents: rowsToEvents, parseTime: parseTime, boot: boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
